import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const setSortByReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string>) => {
    state.sortBy = action.payload;
  });
};

export default setSortByReducer;
